import React from 'react';
import BaseSkeleton from '../../common/skeleton';

export default function Skeleton() {
  return (
    <div className="claim-box claim-box-skeleton bg-transparent p-0">
      <BaseSkeleton className="w-100 h-100 rounded-0" />
    </div>
  );
}
